import { Grid } from '@material-ui/core';
import TitleAndMetadata from './TitleAndMetaData';
import { ModuleVideos } from './ModuleVideos';
import React, { useState } from 'react';
import { CourseDetails } from '../../../../../shared/constants';

export const ModuleDetails = ({ classes, data }) => {
  const [seeAll, setSeeAll] = useState(false);

  const toggleSeeAll = () => setSeeAll(!seeAll);
  const clips = seeAll ? data.clips : data.clips.slice(0, CourseDetails.defaultShowClips);

  return (
    <Grid container>
      <Grid item xs={12}>
        <TitleAndMetadata
          title={data.moduleName}
          numVideos={data.numVideos}
          duration={data.moduleDuration}
          onClickSeeAll={toggleSeeAll}
        />
      </Grid>
      <Grid item xs={12}>
        <ModuleVideos clips={clips} seeAll={seeAll} />
      </Grid>
    </Grid>
  );
};
